import { render, staticRenderFns } from "./FormCheckboxChangeNames.vue?vue&type=template&id=903e9b52"
import script from "./FormCheckboxChangeNames.vue?vue&type=script&lang=js"
export * from "./FormCheckboxChangeNames.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports